import { getMediaUrl } from "@/lib/api/getUrl";
import type { IVideo } from "@/shared/models/content/videos";
import type { IFocusArea } from "@/shared/models/focus-area.model";
import { createUrl } from "@/shared/utils/slug-utils";

export function getYoutubeVideoId(url: string) {
  try {
    const parsed = new URL(url);
    if (parsed.hostname === "youtu.be") return parsed.pathname.slice(1).split("/")[0] || null;
    if (parsed.hostname.includes("youtube.com")) {
      if (parsed.pathname.startsWith("/embed/")) return parsed.pathname.split("/")[2] || null;
      if (parsed.pathname.startsWith("/shorts/")) return parsed.pathname.split("/")[2] || null;
      return parsed.searchParams.get("v");
    }
  } catch {
    return null;
  }
  return null;
}

export function getVideoThumbnailCandidates(video: IVideo, focusArea?: IFocusArea) {
  const youtubeId = getYoutubeVideoId(video.videoUrl);
  const candidates = [
    youtubeId ? `https://i.ytimg.com/vi/${youtubeId}/hqdefault.jpg` : null,
    focusArea?.coverPhoto?.fileName ? getMediaUrl(focusArea.coverPhoto.fileName) : null,
    focusArea?.photo?.fileName ? getMediaUrl(focusArea.photo.fileName) : null
  ].filter((value): value is string => Boolean(value));
  return Array.from(new Set(candidates));
}

export function getVideoWatchHref(video: IVideo, returnHref = "/video-library") {
  const slug = createUrl(video.id, video.title);
  return `/video-library/watch/${slug}?from=${encodeURIComponent(returnHref)}`;
}

export function getYoutubeEmbedUrl(url: string) {
  const youtubeId = getYoutubeVideoId(url);
  return youtubeId
    ? `https://www.youtube-nocookie.com/embed/${youtubeId}?autoplay=1&rel=0&modestbranding=1`
    : null;
}
